import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BaseParamsService } from '@app/core/base-params.service';
import { environment } from '@env/environment';
import { SessionApiProvider } from '@app/core/session/session-api-provider';
import { WithRedirectUrl } from '@app/core/_models/redirectUrl';

@Injectable()
export class SessionOidcApiService implements SessionApiProvider {

  constructor(private http: HttpClient,
              private baseParamsService: BaseParamsService) { }

  public startOidcSignIn(): Observable<string> {
    const params: Record<string, any> = {};
    const language = this.baseParamsService.language;
    if (language) {
      params.language = language;
    }

    return this.http.post(
      `${this.getOidcSessionUrl()}`,
      {},
      { params },
    ).pipe(
      map(({ redirect_url }: WithRedirectUrl) => redirect_url),
    );
  }

  public signOut(): Observable<unknown> {
    return this.http.delete(
      `${this.getOidcSessionUrl()}`,
    ).pipe(
      map(({ redirect_url }: WithRedirectUrl) => redirect_url),
      switchMap(url => this.http.get(url)),
    );
  }

  public authenticateBasically(): Observable<boolean> {
    return this.http.get<{ status: string }>(
      `${this.getOidcSessionUrl()}`,
    ).pipe(
      map(() => true),
      catchError(() => of(false)),
    );
  }

  private getOidcSessionUrl(): string {
    return `${this.getBaseUrl()}/oidc_sessions`;
  }

  private getBaseUrl(): string {
    return `${environment.webforms_api}/v2/${this.currentSlug()}`;
  }

  private currentSlug(): string {
    return this.baseParamsService.slug;
  }
}
